/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Bundle_Bundleoffers1Inputs */

const id_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Bundel`)
};

const ms_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Bundle`)
};

const da_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle-tilbud`)
};

const de_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle-Angebote`)
};

const en_us2_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Offers`)
};

const es_es2_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de bundle`)
};

const es_mx2_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de paquete`)
};

const fil_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Bundle Offer`)
};

const fr_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres groupées`)
};

const it_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte bundle`)
};

const hu_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomag ajánlatok`)
};

const nl_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundelaanbiedingen`)
};

const no_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunttilbud`)
};

const pl_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty pakietu`)
};

const pt_br2_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Offers`)
};

const pt_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de pacote`)
};

const ro_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte pachet`)
};

const fi_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakettitarjoukset`)
};

const sv_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketerbjudanden`)
};

const vi_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi gói`)
};

const tr_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Teklifleri`)
};

const cs_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky balíčku`)
};

const bg_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетни оферти`)
};

const ru_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетные предложения`)
};

const uk_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиції в наборі`)
};

const ar_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض الحزمة`)
};

const hi_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंडल ऑफ़र`)
};

const th_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอชุดรวม`)
};

const ja_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バンドルオファー`)
};

const zh_cn2_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Offers`)
};

const zh_hant1_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Offers`)
};

const ko_components_bundle_bundleoffers1 = /** @type {(inputs: Components_Bundle_Bundleoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle Offers`)
};

/**
* | output |
* | --- |
* | "Bundle Offers" |
*
* @param {Components_Bundle_Bundleoffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_bundleoffers1 = /** @type {((inputs?: Components_Bundle_Bundleoffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Bundleoffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_bundleoffers1(inputs)
	if (locale === "ms") return ms_components_bundle_bundleoffers1(inputs)
	if (locale === "da") return da_components_bundle_bundleoffers1(inputs)
	if (locale === "de") return de_components_bundle_bundleoffers1(inputs)
	if (locale === "en-US") return en_us2_components_bundle_bundleoffers1(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_bundleoffers1(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_bundleoffers1(inputs)
	if (locale === "fil") return fil_components_bundle_bundleoffers1(inputs)
	if (locale === "fr") return fr_components_bundle_bundleoffers1(inputs)
	if (locale === "it") return it_components_bundle_bundleoffers1(inputs)
	if (locale === "hu") return hu_components_bundle_bundleoffers1(inputs)
	if (locale === "nl") return nl_components_bundle_bundleoffers1(inputs)
	if (locale === "no") return no_components_bundle_bundleoffers1(inputs)
	if (locale === "pl") return pl_components_bundle_bundleoffers1(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_bundleoffers1(inputs)
	if (locale === "pt") return pt_components_bundle_bundleoffers1(inputs)
	if (locale === "ro") return ro_components_bundle_bundleoffers1(inputs)
	if (locale === "fi") return fi_components_bundle_bundleoffers1(inputs)
	if (locale === "sv") return sv_components_bundle_bundleoffers1(inputs)
	if (locale === "vi") return vi_components_bundle_bundleoffers1(inputs)
	if (locale === "tr") return tr_components_bundle_bundleoffers1(inputs)
	if (locale === "cs") return cs_components_bundle_bundleoffers1(inputs)
	if (locale === "bg") return bg_components_bundle_bundleoffers1(inputs)
	if (locale === "ru") return ru_components_bundle_bundleoffers1(inputs)
	if (locale === "uk") return uk_components_bundle_bundleoffers1(inputs)
	if (locale === "ar") return ar_components_bundle_bundleoffers1(inputs)
	if (locale === "hi") return hi_components_bundle_bundleoffers1(inputs)
	if (locale === "th") return th_components_bundle_bundleoffers1(inputs)
	if (locale === "ja") return ja_components_bundle_bundleoffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_bundleoffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_bundleoffers1(inputs)
	return ko_components_bundle_bundleoffers1(inputs)
});
export { components_bundle_bundleoffers1 as "components.bundle.bundleOffers" }